import GruposAdmin from "../../../components/GruposAdmin";

export function GruposGeral() {
    return (
        <GruposAdmin
            tipo="ofertas"
            titulo="Controle de Acessos - Grupo Geral"
        />
    );
}

export function GruposCelular() {
    return (
        <GruposAdmin
            tipo="celular"
            titulo="Controle de Acessos - Grupo Celular"
        />
    );
}
